import styled from 'styled-components'

export const StyledForbiddenModal = styled.div`
  .C-Modal {
    z-index: 11;
  }
`
